/**
 * Admin Service
 *
 * Data access for admin-only user management. Backed by /api/admin, which is
 * gated server-side by the ADMIN_EMAILS allowlist.
 */

import { apiGet, apiPost } from '@/lib/api';

const CONTEXT = 'admin';

export interface AdminUser {
  id: string;
  email: string;
  subscription_status: string;
  free_pass_until: string | null;
  free_pass_granted_by: string | null;
  free_pass_granted_at: string | null;
  free_pass_note: string | null;
  created_at: string;
}

/** List/search users (newest first). Empty search returns the most recent. */
export async function listUsers(search = ''): Promise<AdminUser[]> {
  return apiGet<AdminUser[]>('/admin/users', `${CONTEXT}.listUsers`, {
    params: search ? { search } : undefined,
    defaultValue: [],
  });
}

export interface SetFreePassInput {
  /** Future ISO date to grant the pass until, or null to revoke. */
  until: string | null;
  note?: string | null;
}

/** Grant (future date) or revoke (null) a user's free pass. */
export async function setFreePass(userId: string, input: SetFreePassInput): Promise<AdminUser> {
  return apiPost<AdminUser>(`/admin/users/${userId}/free-pass`, `${CONTEXT}.setFreePass`, input);
}

export const adminService = {
  listUsers,
  setFreePass,
};
